import { HighlightsViewStore } from "@state/stores/offer/home/HighlightsViewStore";
import {
	HomePageStoreConstructorsParameters,
	ISportSliderHeaderStore,
	StoreMap,
	StoreTypeEnum,
} from "@state/stores/offer/home/ISportSliderHeaderStore";
import { LastMinuteViewStore } from "@state/stores/offer/home/LastMinuteViewStore";
import { LiveHighlightsViewStore } from "@state/stores/offer/home/LiveHighlightsViewStore";
import { MostPlayedViewStore } from "@state/stores/offer/home/MostPlayedViewStore";

export default class HomeStoreManager {
	private registry: {
		[K in keyof StoreMap]: new (
			params: HomePageStoreConstructorsParameters
		) => StoreMap[K];
	} = {
		[StoreTypeEnum.HighlightsViewStore]: HighlightsViewStore,
		[StoreTypeEnum.LiveHighlightsViewStore]: LiveHighlightsViewStore,
		[StoreTypeEnum.LastMinuteViewStore]: LastMinuteViewStore,
		[StoreTypeEnum.MostPlayedViewStore]: MostPlayedViewStore,
	};
	private lastUsedInstance: ISportSliderHeaderStore | null = null;
	private instances = new Map<StoreTypeEnum, ISportSliderHeaderStore>();

	constructor() {}

	getStore<T extends StoreTypeEnum>(
		type: T,
		params: HomePageStoreConstructorsParameters
	): StoreMap[T] {
		if (!this.instances.has(type)) {
			const StoreClass = this.registry[type];
			this.instances.set(type, new StoreClass(params));
		}
		this.lastUsedInstance = this.instances.get(type)!;
		return this.instances.get(type)! as StoreMap[T];
	}

	refreshStores() {
		this.instances.forEach((instance) => {
			if (instance === this.lastUsedInstance) {
				instance.onDispose();
				instance.onInitialize();
			} else {
				this.disposeStore(instance.type);
			}
		});
	}

	disposeStore(type: StoreTypeEnum) {
		this.instances.get(type)?.onDispose();
		this.instances.delete(type);
	}

	onDispose() {
		this.instances.forEach((instance) => {
			instance.onDispose();
			this.disposeStore(instance.type);
		});
		if (this.lastUsedInstance) {
			this.lastUsedInstance = null;
		}
	}
}
